import React from "react";
import Icon from '@ant-design/icons';
import { ReactComponent as MessageSvg } from './RecordingPatientSVG.svg';

const IconPatient = (props) => {
  return (<Icon component={MessageSvg} {...props} />);
}

export default IconPatient;